<template>
  <section>
    <common-btn
      :class="['shareBtn', type]"
      @click="toShare"
      :btnText="btnText"
      tipsLeft="50%"
      :tipsText="tipsText"
      :hasTips="hasTips"
      :type="type"
      :shareDesc="shareDesc"
      btnType="share"
      :registerAwardsType="registerAwardsType"
      :couponType="couponType"
    />
  </section>
</template>
<script>
  import CommonBtn from './index.vue'
  import { mapState, mapMutations } from 'vuex'
  import { getQuery } from '@/utils/utils'
  import { userShare, getUserPoints } from '@/api/fission'

  export default {
    components: {
      CommonBtn,
    },
    props: {
      type: {
        type: String,
        default: 'page', // page: 页面, popup: 弹框
      },
      tipsText: {
        type: String,
        default: '',
      },
      activityId: {
        type: String,
        default: '',
      },
      btnText: {
        type: String,
        default: '',
      },
      firstShareStatus: {
        type: Boolean,
        default: false,
      },
      hasTips: {
        type: Boolean,
        default: false,
      },
      registerAwardsType: {
        type: String,
        default: '',
      },
      couponType: {
        type: [Number, String],
        default: '',
      },
    },
    data() {
      return {
        // userFirstShare: this.firstShareStatus ? 2 : 1, // 1: 未首次分享，2：已首次分享
        activitySource: getQuery('activitySource') || getQuery('source'), //活动生效渠道
      }
    },
    computed: {
      ...mapState([
        'shareInfos',
        'region',
        'gameName',
        'fissionInfos',
        'fissionFirstShareStatus',
      ]),
      shareDesc() {
        const { extraInfo = {} } = this.fissionInfos || {}
        // 有可能未配置 shareButtonDesc firstShareDesc
        const { shareButtonDesc, firstShareDesc } = extraInfo
        return this.fissionFirstShareStatus
          ? shareButtonDesc
          : firstShareDesc || shareButtonDesc
      },
      descForNewUser() {
        const { extraInfo } = this.fissionInfos || {}
        // 有可能未配置
        return extraInfo?.toShareRegisterButtonDesc
      },
    },
    watch: {
      shareInfos(data = {}) {
        if (data && data.id) {
          const { activityId, game = '' } = this.fissionInfos || {}
          if (!activityId) {
            return
          }
          getUserPoints({
            game,
            country: this.region,
            activityId,
            source: this.activitySource,
          }).then((res) => {
            const { shareStatus } = res || {}
            this.setFissionFirstStatus(shareStatus * 1 === 2)
            userShare({
              game,
              country: this.region,
              activityId,
              source: data.id,
            })
              .then(() => {})
              .finally(() => {
                this.setShareInfosReportFinished(true)
                this.setShareInfos(null)
              })
          })
        }
      },
    },
    methods: {
      ...mapMutations([
        'setShareInfosReportFinished',
        'setShareInfos',
        'setFissionFirstStatus',
      ]),
      toShare() {
        this.$emit('click-share')
      },
    },
  }
</script>
